export default {
  field_from_api: {
    clue: {
      name: '线索',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '占比',
          is_rate: true
        }
      }
    },
    arrived: {
      name: '到店',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '到店率',
          is_rate: true
        }
      }
    },
    deal: {
      name: '成交',
      map: {
        count: {
          name: '合计'
        },
        rate: {
          name: '成交率',
          is_rate: true
        }
      }
    },
    clue_to_deal_rate: {
      name: '线索转化率',
      is_rate: true,
      map: {}
    }
  },
  getData (params) {
    this.$rest.dataAnalysis.getAreaStatistical(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
